module.exports = __webpack_public_path__ + "media/images/18px_halfstar-d3e1954ab1afb00f5e04c12ef1fafa41a14a4c20aba98c4591c54b1df215271f.png";